<div class="p-1 h-full">
  <app-tool-loader [isLoading]="isLoading() && !calculating()" [positionUnset]="true">
    <div class="p-1 h-full">
      <p-scrollPanel [style]="{ width: '100%', height: '100%' }">
        @if (calculating()) {
          <p-dialog modal="true" [(visible)]="calculating" [draggable]="false">
            <i class="pi pi-exclamation-circle"></i> Please wait while Reservoir Performance is being calculated <br />
            <br />
          </p-dialog>
        }

      @if (reservoirPerformanceForm && userUnits && !isLoading()) {
      <form [formGroup]="reservoirPerformanceForm">
        <div class="flex flex-wrap gap-2 m-2">

          <div class="flex-1">
          <p-fieldset legend="Input Configuration">
            <div class="flex flex-col space-y-2 mb-2">

              <div class="flex flex-col">
                <label for="type">Operation Type</label>
                <p-select 
                  [options]="operationTypes" formControlName="operationType" optionLabel="name" appendTo="body"
                  optionValue="value" (onChange)="selectedOperationChange($event)" 
                  placeholder="Select Operation Type">
                </p-select>
              </div>

              <div class="flex flex-col">
                <label>Fluid</label>
                <p-select [options]="fluids" optionLabel="state.name" appendTo="body"
                  (onChange)="selectedFluidChange($event)"></p-select>
              </div>

              <div class="flex flex-col">
                <label>Gas Flow Rate</label>
                <app-validated-number-input
                  [id]="'gasFlowRate'"
                  [control]="control('gasFlowRate')"
                  [value]="control('gasFlowRate').value"
                  [validation]="{ min: gasFlowRateValidation.min, max: gasFlowRateValidation.max }"
                  [unit]="gasFlowRateUnit"
                  [inline]="false"
                ></app-validated-number-input>
              </div>

              @if (selectedOperationType === 'injection') {
                <div class="flex flex-col">
                  <label>Bottomhole Temperature</label>
                  <app-validated-number-input
                    [id]="'bottomholeTemperature'"
                    [control]="control('bottomholeTemperature')"
                    [value]="control('bottomholeTemperature').value"
                    [validation]="{ min: temperatureValidation.min, max: temperatureValidation.max }"
                    [unit]="tempUnit"
                    [inline]="false"
                  ></app-validated-number-input>
                </div>
              }

              <div class="flex flex-col">
                <label>Bottomhole Diameter</label>
                  <app-validated-number-input
                    [id]="'bottomholeDiameter'"
                    [control]="control('bottomholeDiameter')"
                    [value]="control('bottomholeDiameter').value"
                    [validation]="{ min: 0, max: 100000000 }"
                    [unit]="userUnits?.shortLengths"
                    [unitPrecisionOverrides]="{ 'in': 2, 'cm': 2, 'mm': 2 }"
                    [inline]="false"
                  ></app-validated-number-input>
              </div>

            <p-fieldset legend="Reservoir Fluid PVT Conditions">
            
              <div class="flex flex-col">
                <div class="flex items-center space-x-2">
                  <input
                    type="radio"
                    binary="true"
                    id="bottomHole"
                    (click)="pvtConditionsChange('bottomHole')"
                    [checked]="pvtCondition === 'bottomHole'"
                  >
                  <label for="bottomHole">Flowing Bottom-Hole</label>
                </div>
                <div class="flex items-center space-x-2">
                  <input
                    type="radio"
                    binary="true"
                    id="farField"
                    (click)="pvtConditionsChange('farField')"
                    [checked]="pvtCondition === 'farField'"
                  >
                  <label for="farField">Far-field Reservoir</label>
                </div>
                <div class="flex items-center space-x-2">
                  <input
                    type="radio"
                    binary="true"
                    id="average"
                    (click)="pvtConditionsChange('average')"
                    [checked]="pvtCondition === 'average'"
                  >
                  <label for="average">Average Reservoir Conditions</label>
                </div>
              </div>

            </p-fieldset>

            <div class="flex flex-col">
              <label>Perforation</label>
              <p-select formControlName="perf" [options]="perforations" optionLabel="name" appendTo="body"
              (onChange)="onPerforationsChange($event)" appendTo="body"></p-select>
            </div>

            <div class="flex flex-col">
              <label>Reservoir Temperature</label>
              <app-validated-number-input
                [id]="'reservoirTemperature'"
                [control]="control('reservoirTemperature')"
                [value]="control('reservoirTemperature').value"
                [validation]="{ min: temperatureValidation.min, max: temperatureValidation.max }"
                [unit]="tempUnit"
                [inline]="false"
              ></app-validated-number-input>
            </div>
            
            <div class="flex flex-col mt-2">
              <label for="type">Reservoir</label>
              <p-select
                formControlName="reservoir"
                [options]="reservoirs"
                optionLabel="name"
                appendTo="body"
                (onChange)="selectedReservoirChange($event)"
              ></p-select>
            </div>

          </div>
          </p-fieldset>
        </div>

        <div class="flex-1">
          <p-fieldset legend="Performance Output">
            <div class="flex flex-col space-y-2">

              <div class="flex flex-col">
                <label>Bottomhole Pressure</label>
                <p-inputgroup disabled="true">
                  <p-inputNumber [minFractionDigits]="1" [disabled]="true"
                    placeholder="{{ reservoirPerformanceResult?.bottomholePressure }}"></p-inputNumber>
                  <p-inputgroup-addon>{{ userUnits?.pressure }}</p-inputgroup-addon>
                </p-inputgroup>
              </div>

              <div class="flex flex-col">
                <label>Performance Index (J)</label>
                <p-inputgroup disabled="true">
                  <p-inputNumber [minFractionDigits]="2" [disabled]="true"
                    placeholder="{{ reservoirPerformanceResult?.performanceIndex }}"></p-inputNumber>
                  <p-inputgroup-addon>ft³/hr/psi</p-inputgroup-addon>
                </p-inputgroup>
              </div>

              <div class="flex flex-col">
                <label class="mr-2">Effective Mass Flow Rate
                  <i pTooltip="Production (+) / Injection (-)" class="pi pi-info-circle cursor-help"></i>
                </label>
                <p-inputgroup>
                  <p-inputNumber [minFractionDigits]="1" [disabled]="true"
                    placeholder="{{ reservoirPerformanceResult?.effectiveMassFlowRate }}"></p-inputNumber>
                  <p-inputgroup-addon>{{ massFlowUnit }}</p-inputgroup-addon>
                </p-inputgroup>
              </div>

              <div class="flex flex-col">
                <label>Reservoir Phase</label>
                <p-inputNumber [minFractionDigits]="1" [disabled]="true"
                  placeholder="{{ reservoirPerformanceResult?.reservoirPhase }}"></p-inputNumber>
              </div>

              <div class="flex flex-col">
                <label>Reservoir Vapor Quality</label>
                <p-inputNumber [minFractionDigits]="1" [disabled]="true"
                  placeholder="{{ reservoirPerformanceResult?.reservoirVaporQuality }}"></p-inputNumber>
              </div>
            </div>
          </p-fieldset>

          <div class="flex justify-center mt-5">
            <p-button class="outlined-button" [disabled]="reservoirPerformanceForm?.invalid" size="small" severity="success"
              outlined="true" label="Calculate" (onClick)="calculateReservoirPerformance()">
            </p-button>
          </div>

        </div>

        </div>
      </form>
      }
    </p-scrollPanel>
    </div>
  </app-tool-loader>
</div>